

export class CountryOutputWithStatus implements ICountryOutputWithStatus {
    /** The auto-generated id of the country master */
    country_id!: number;
    /** The country name with 255 character limit */
    country_name!: string;
    /** Manage status of country. 0 For De-active, 1 For Active */
    status!: number;
    /** The total state available in country */
    total_state!: number;

    constructor(data?: ICountryOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country_id = _data["country_id"];
            this.country_name = _data["country_name"];
            this.status = _data["status"];
            this.total_state = _data["total_state"];
        }
    }

    static fromJS(data: any): CountryOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CountryOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country_id"] = this.country_id;
        data["country_name"] = this.country_name;
        data["status"] = this.status;
        data["total_state"] = this.total_state;
        return data; 
    }
}

export interface ICountryOutputWithStatus {
    /** The auto-generated id of the country master */
    country_id: number;
    /** The country name with 255 character limit */
    country_name: string;
    /** Manage status of country. 0 For De-active, 1 For Active */
    status: number;
    /** The total state available in country */
    total_state: number;
}

